import SaveCartPopUp from "./savecartpopup"
import React, { useEffect, useState } from 'react';
import { conatinerIprops } from "./savecartpopupinterface";

const SaveCartPopUpContainer = (props: conatinerIprops) => {

    const [saveCartDetails, setSaveCartDetails] = useState<any>({});
    const [isShowAlert, setIsShowAlert] = useState<any>(false);

    useEffect(() => {
        setSaveCartDetails({ ...saveCartDetails, selectedListType: 'cust' })
    }, []);

    const onNameChange = (value: string | number) => {
        setSaveCartDetails({ ...saveCartDetails, shoppingListName: value })
    };

    const handleRadioChange = (event: any) => {
        setSaveCartDetails({ ...saveCartDetails, selectedListType: event?.target?.id });
    };

    const handleIsShowAlert = (isShow: boolean) => {
        setIsShowAlert(isShow);
    };

    const onSaveChanges = () => {
        if (saveCartDetails?.shoppingListName) {
            props?.SaveOnClick(saveCartDetails);
        } else {
            handleIsShowAlert(true)
        }
    };

    return (
        <SaveCartPopUp
            closePopup={props?.closePopup}
            onNameChange={onNameChange}
            saveCartDetails={saveCartDetails}
            onSaveChanges={onSaveChanges}
            isShowAlert={isShowAlert}
            handleIsShowAlert={handleIsShowAlert}
            handleRadioChange={handleRadioChange}
            isQuote={props?.isQuote}
        />
    )
}
export default SaveCartPopUpContainer